import PropTypes from 'prop-types';
import React from 'react';
import EmployeeFillForm from './EmployeeFillForm';
import RemoteW4v0 from './RemoteW4v0';

function W4VersionAdapter(props) {
  const {
    action,
    title,
    onSignedSuccess,
    companyStaff,
    viewResultAsManager,
    prefilledData,
    dataFromEi,
    processData,
    company,
  } = props;
  const innerIsOnboardingV2 = isOnboardingV2 === 'true';

  if (innerIsOnboardingV2) {
    return (
      <EmployeeFillForm
        action={action}
        title={title}
        onSignedSuccess={onSignedSuccess}
        companyStaff={companyStaff}
        viewResultAsManager={viewResultAsManager}
        prefilledData={prefilledData}
        dataFromEi={dataFromEi}
      />
    );
  }

  return (
    <RemoteW4v0
      company={company}
      processData={processData}
      action={action}
      onSignedSuccess={onSignedSuccess}
      viewResultAsManager={viewResultAsManager}
    />
  );
}

W4VersionAdapter.defaultProps = {
  prefilledData: {},
  dataFromEi: {},
  viewResultAsManager: false,
};

W4VersionAdapter.propTypes = {
  company: PropTypes.shape().isRequired, // for new w4 form
  processData: PropTypes.shape().isRequired, // for new w4 form
  action: PropTypes.shape().isRequired,
  title: PropTypes.string.isRequired,
  onSignedSuccess: PropTypes.func.isRequired,
  companyStaff: PropTypes.shape().isRequired,
  prefilledData: PropTypes.shape(),
  dataFromEi: PropTypes.shape(),
  viewResultAsManager: PropTypes.bool,
};

export default W4VersionAdapter;
